module.exports = __webpack_public_path__ + "img/knight-angel.9ddbfc45.svg";